import { notification } from "tea-component";
import { MANAGER_GROUP_NAME } from '@intelligence/pages/Following/_config/constant';

import type { IFollowingGroup } from '@intelligence/pages/Following/Manage/types';

//根据keyType返回游戏类型和新旧
//只用一个字段判断哪个游戏与新还是旧
export const getGameStateType = (currentType: string) => {
  let obj = {
    type: 'mobile',
    state: 'currentgames'
  }
  switch (currentType) {
    case 'mobile':
      obj.type = 'mobile';
      obj.state = 'currentgames';
      break;
    case 'pc':
      obj.type = 'pc';
      obj.state = 'currentgames';
      break;
    case 'console':
      obj.type = 'console';
      obj.state = 'currentgames';
      break;
    case 'company':
      obj.type = 'company';
      obj.state = 'currentgames';
      break;
    case 'mobile_new':
      obj.type = 'mobile';
      obj.state = 'newgames';
      break;
    case 'pc_new':
      obj.type = 'pc';
      obj.state = 'newgames';
      break;
    case 'console_new':
      obj.type = 'console';
      obj.state = 'newgames';
      break;
  }
  return obj;
}

export const getCopyName = (groupList: any[], name: string) => {
  let i = 1;
  let copyName = `${name} - copy`;
  let isDuplicate = true
  while (isDuplicate) {
    isDuplicate = groupList.filter((item: any) => {
      return item?.entity_name == copyName
    })?.length > 0

    if (isDuplicate) {
      i++
      copyName = `${name} - copy ${i}`
    }
  }
  return copyName;
}

export const segOptions = [
  { text: "Mobile Games", value: "mobile" },
  { text: "PC Games", value: "pc" },
  { text: "Console Games", value: "console" },
  { text: "Company", value: "company" },
];
export const DEFAULTPAGESIZE = 20;

export const notificationMsg = (type: 'success' | 'error', text: string) => {
  switch (type) {
    case 'success':
      notification.success({
        unique: true,
        duration: 3000,
        description: text,
      });
      break;
    case 'error':
    default:
      return notification.error({
        unique: true,
        duration: 3000,
        description: text,
      });
  }
}

export const getManagerDbiPageLogMes = (type: string) => {
  switch (type) {
    case 'mobile':
      return 'followingManageMobile';
    case 'pc':
      return 'followingManagePC';
    case 'console':
      return 'followingManageConsole';
    case 'company':
      return 'followingManageCompanies';
    default:
      return 'followingManageMobile';
  }
}

/**
 * 解析接口返回的分组集合，拆分为全部分组、All Games分组
 * @param groups 接口返回的分组，包含了All Games分组和其他分组
 * @returns all为全部分组，allGames为All Games分组
 */
export const analysisGroups = <T extends IFollowingGroup>(
  groups?: T[],
): {
  all: T[];
  allGames: T[];
} => {
  if (!Array.isArray(groups)) return { all: [], allGames: [] };
  const all = [];
  const allGames = [];
  for (const group of groups) {
    const groupEntityName = group?.entity_name;
    let groupGames: any[] = [];
    if (!groupEntityName) continue;
    groupGames = group?.group_game_ids?.map((id) => {
      return { app_id: id };
    });
    const allGroup = { ...group, game_list: groupGames };
    if (groupEntityName === MANAGER_GROUP_NAME.allgames.text) {
      allGroup.group_id = 'allgames';
      allGames.push({
        ...group,
        group_id: 'allgames',
        game_list: groupGames,
      });
    }
    all.push(allGroup);
  }
  return { all, allGames };
};
